<div class="ui container" appMargin appPadding paddingB='30'>


    <div class='ui vertical basic segment' [ngClass]="{'loading':pending}">
        <div fxLayout="row" fxLayoutAlign='space-between center'>
            <div fxLayoutAlign='start center' fxLayout='row' fxLayoutGap='20px' (click)="goBack()" class="link">
                <div >
                    <img src="assets/icons/left-arrow-icon.svg" alt="">
                </div>
                <div class='equipment-id'>
					<!-- Title -->
                    <h2 class="ui primary header">Amos Okafor</h2>
                </div>
            </div>

              <div fxLayout='row' fxLayoutGap='15px'>

					<button class="ui basic small  primary  button" (click)="goBack()" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="cancel template creation">
						Delete
						</button>

					<button class="ui small  primary  button" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="save template">
						Save
						</button>
					</div>

		</div>
		<div class="ui divider" appMargin marginY="3"></div>
    <div *ngIf="success || error">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>

    </div>

		<div fxLayout="row" fxLayoutGap='50px'>
			<div fxFlex="30%">
				<div class="ui form side-panel text-center"  appPadding="15px">

					<div class="field">
						<img class="avatar" src="assets/images/avatar.svg"/>
						</div>
								<div class="field">
						<button class="ui primary button">Change</button>
						</div>
				</div>
					</div>
				<div fxFlex="grow">
					<div fxLayout="row" fxLayoutAlign='space-between center'>
						<h3 appMargin marginB="0">User Details</h3>
						</div>
						<hr>


						<div class="ui vertical basic segment">

								<div fxLayout="row">
									<div fxFlex="40%"><strong>Staff ID</strong></div>
									<div fxFlex="grow">4901874</div>
								</div>
								<div class="ui divider"></div>

									<div fxLayout="row">
									<div fxFlex="40%"><strong>Role </strong></div>
									<div fxFlex="grow">Head of Department</div>
								</div>
								<div class="ui divider"></div>


									<div fxLayout="row">
									<div fxFlex="40%"><strong>Email</strong></div>
									<div fxFlex="grow">amos.okafor&#64;ncc.gov.ng</div>
								</div>
								<div class="ui divider"></div>


									<div fxLayout="row">
									<div fxFlex="40%"><strong>Phone Number</strong></div>
									<div fxFlex="grow">0812 784 3389</div>
								</div>
								<div class="ui divider"></div>

									<div fxLayout="row">
									<div fxFlex="40%"><strong>Department</strong></div>
									<div fxFlex="grow">Compliance</div>
								</div>
								<div class="ui divider"></div>

									<div fxLayout="row">
									<div fxFlex="40%"><strong>Unit</strong></div>
									<div fxFlex="grow"><label class="ui green circular label">Service and VAS</label></div>
								</div>
								<div class="ui divider"></div>

									<div fxLayout="row">
									<div fxFlex="40%"><strong>Level</strong></div>
									<div fxFlex="grow">Associate</div>
								</div>
								<div class="ui divider"></div>

										<div fxLayout="row">
									<div fxFlex="40%"><strong>Step</strong></div>
									<div fxFlex="grow">5</div>
								</div>
								<div class="ui divider"></div>

										<div fxLayout="row">
									<div fxFlex="40%"><strong>Date Added</strong></div>
									<div fxFlex="grow">Jun 12th, 2021</div>
								</div>
								<div class="ui divider"></div>

						</div>

				</div>
			</div>

</div>
